"use client"

import { useState } from "react"
import { Container, Title, Text, Paper, Alert, Center, Stack, Button, TextInput, TbAlertCircle, TbCheck } from "@forestsync/ui"
import { useTranslations } from "next-intl"
import { forgotPasswordAction } from "@/actions/auth"
import Link from "next/link"

export default function ForgotPasswordPage() {
  const t = useTranslations("auth")
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle")
  const [message, setMessage] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setStatus("loading")
    setMessage(null)

    const formData = new FormData(e.currentTarget)
    const result = await forgotPasswordAction(formData)

    if (result.error) {
      setStatus("error")
      setMessage(result.error)
    } else {
      setStatus("success")
      setMessage(t("forgotPasswordSuccess"))
    }
  }

  return (
    <Container size="xs" py="xl">
      <Center mb="xl">
        <div>
          <Title order={1} ta="center">{t("forgotPasswordTitle")}</Title>
          <Text c="dimmed" ta="center" mt="sm">{t("forgotPasswordSubtitle")}</Text>
        </div>
      </Center>

      <Paper withBorder shadow="md" p="xl" radius="md">
        {status === "success" ? (
          <Stack align="center" gap="md">
            <Alert icon={<TbCheck size={16} />} color="green" variant="light" w="100%">
              {message}
            </Alert>
            <Button component={Link} href="/login" variant="subtle">
              {t("backToLogin")}
            </Button>
          </Stack>
        ) : (
          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              {status === "error" && (
                <Alert icon={<TbAlertCircle size={16} />} color="red" variant="light">
                  {message}
                </Alert>
              )}
              <TextInput
                name="email"
                type="email"
                label={t("email")}
                placeholder={t("enterEmail")}
                required
              />
              <Button type="submit" fullWidth loading={status === "loading"}>
                {status === "loading" ? t("forgotPasswordSending") : t("forgotPasswordButton")}
              </Button>
              <Text ta="center" size="sm">
                <Text component={Link} href="/login" c="blue">
                  {t("backToLogin")}
                </Text>
              </Text>
            </Stack>
          </form>
        )}
      </Paper>
    </Container>
  )
}
